import { AWPrdFilterList } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { userPreferenceApi } from './Base';

export async function getPrdSavedFilters() {
  const path = '/v1/prd-filters';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWPrdFilterList[], 'filters'>>(path);
  return unwrapAGraphResponse(response, 'filters');
}

export async function postCreatePrdSavedFilter(pedSavedFilter: AWPrdFilterList) {
  const path = '/v1/prd-filters';
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'result'>>(path, pedSavedFilter);
  return unwrapAGraphResponse(response, 'result');
}

export async function putUpdatePrdSavedFilter(updatedPedSavedFilter: AWPrdFilterList, id: string) {
  const path = `/v1/prd-filters/${id}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'result'>>(path, updatedPedSavedFilter);
  return unwrapAGraphResponse(response, 'result');
}

export function deletePrdSavedFilter(id: string) {
  const path = `/v1/prd-filters/${id}`;
  return userPreferenceApi.delete<string>(path);
}

export function getPrdSavedFilter(id: string) {
  const path = `/v1/prd-filters/${id}`;
  return userPreferenceApi.get<AWPrdFilterList>(path);
}
